import React, { useMemo } from 'react';

import { useSettings } from '@atlas/core';
import { Label } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

export const FirstStep = () => {
  const { theme } = useSettings();

  const imgSrc = useMemo(
    () => `${BASE_PATH}/static/assets/images/add-to-home-screen/step-1-${theme || 'dark'}.svg`,
    [theme],
  );

  return (
    <div className="add-to-home-screen-ios-popup__step">
      <div className="add-to-home-screen-ios-popup__step-title title-big-bold-text">
        <Label message="add_to_home_screen_popup_step" />1
      </div>
      <Label className="sub-title-400-text" message="add_to_home_screen_popup_step_1_text" />
      <img alt="pwa-popup" className="add-to-home-screen-ios-popup__step-image" src={imgSrc} />
    </div>
  );
};
